import {
  useFormContext,
  Controller,
  FieldValues,
  FieldPath,
} from "react-hook-form"
import { FormItem } from "react-hook-form-antd"
import { RichTextEditor } from "@mimber/ui-web"
import type { RichTextEditorFieldProps } from "./RichTextEditorField.types"

export function RichTextEditorField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder,
  disabled,
  minHeight = 200,
  disableImages,
  showVariableInsert,
  variableItems,
}: RichTextEditorFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
    >
      <Controller
        name={name}
        control={formControl}
        render={({ field, fieldState }) => (
          <RichTextEditor
            value={field.value ?? ""}
            onChange={field.onChange}
            placeholder={placeholder}
            disabled={disabled}
            minHeight={minHeight}
            hasError={!!fieldState.error}
            disableImages={disableImages}
            showVariableInsert={showVariableInsert}
            variableItems={variableItems}
          />
        )}
      />
    </FormItem>
  )
}
